import { RestrictionsType } from "../restrictions/restrictions-type";
export abstract class WorkflowItem {
  id: number;
  status: string;
  workflowType: string;
  createdDate: Date;
  lastModifiedDate: Date;
  details: string;
  createdBy: string;
  restrictionType: RestrictionsType;
  requestedByName: string;
  rejectionReason: string;

  public deserialize(input: any): this {
    this.id = input.id;
    this.status = input.status;
    this.workflowType = input.workflowType;
    this.restrictionType = input.restrictionType;
    this.createdDate = this.parseDate(input.createdDate);
    this.lastModifiedDate = this.parseDate(input.lastModifiedDate);
    this.createdBy = input.createdBy;
    this.requestedByName = input.requestedByName || input.createdBy;
    this.rejectionReason = this.isRejected() ? input.comments : null;
    this.details = '';

    return this;
  }

  abstract getTaskDetails(): string;

  /** DOCUMENT_REJECTED is the worker competency service's spelling of the same thing. */
  public isRejected(): boolean {
    return this.status === 'REJECTED' || this.status === 'DOCUMENT_REJECTED';
  }

  protected parseDate(value: any): Date {
    if (!value) {
      return null;
    }

    const parsedDate = value instanceof Date ? value : new Date(value);
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }
};
